<script lang="ts">
    import CaseTags from "./case-tags.svelte";
    import CaseOwners from "./case-owners.svelte";
    import CaseComment from "./case-comment.svelte";
    import type { ActiveOrganization } from "../auth.svelte.js";
    import type { Res } from "@repo/backend/client";

    type CaseTag = Res["Get case tags"][number];
    type TagId = CaseTag["id"];
    type Member = ActiveOrganization["members"][number];

    interface Props {
        caseId: string;
        tags: CaseTag[];
        tagIds: TagId[];
        members: Member[];
        ownerUserIds: string[];
        comment: string | null;
        onChanged?: () => void;
    }

    const { caseId, tags, tagIds, members, ownerUserIds, comment, onChanged }: Props = $props();
</script>

<div class="flex w-fit items-center gap-0.5">
    <CaseOwners {caseId} {members} selectedUserIds={ownerUserIds} {onChanged} compact />
    <CaseComment {caseId} {comment} {onChanged} />
    <CaseTags {caseId} {tags} selectedTagIds={tagIds} {onChanged} />
</div>
